if (!customElements.get('seo-copy')) {
  class SeoCopy extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.seo-copy__toggle');
      this.more = this.querySelector('.seo-copy__more');
      if (!this.toggle || !this.more) return;

      this.toggle.addEventListener('click', this.handleToggle.bind(this));
    }

    handleToggle() {
      const expand = this.toggle.getAttribute('aria-expanded') !== 'true';

      this.more.hidden = !expand;
      this.toggle.setAttribute('aria-expanded', expand);
      this.toggle.textContent = expand ? this.toggle.dataset.labelLess : this.toggle.dataset.labelMore;
      this.classList.toggle('seo-copy__inner--expanded', expand);
    }
  }

  customElements.define('seo-copy', SeoCopy);
}
